module.exports = __webpack_public_path__ + "static/media/s1-alt-no-va.9e839eef.png";